import './About.css'

export default function About() {
  return (
    <section className="about section" id="about" aria-labelledby="about-heading">
      <div className="about__inner container">
        {/* Image / visual side */}
        <div className="about__visual">
          <div className="about__image-wrap">
            <img
              src="/images/jesse-about1.webp"
              alt="Jesse B tattooing in the studio"
              width="500"
              height="600"
              loading="lazy"
            />
          </div>

          {/* Decorative floating tag */}
          <div className="about__float-tag" aria-hidden="true">
            <span className="about__float-icon">✦</span>
            <span>Traditional & Bold</span>
          </div>
        </div>

        {/* Text side */}
        <div className="about__content">
          <span className="about__eyebrow">The Artist</span>
          <h2 className="about__heading" id="about-heading">
            Art Runs In<br />
            <span className="about__heading-script">Every Line</span>
          </h2>

          <div className="about__body">
            <p>
              Hey — I'm Jesse. I've been tattooing for over 5 years and every single piece I
              create starts with one simple goal: making something you'll love for the rest of
              your life.
            </p>
            <p>
              My style is rooted in traditional tattoo culture — bold lines, strong contrast,
              and imagery that pops off the skin, but I bring my own cartoon-influenced, 
              expressive flair to every design. Nothing cookie-cutter. Nothing forgettable.
            </p>
            <p>
              Whether you're after a full sleeve, your first tattoo, or something deeply
              personal through Tattoo Therapy, I'll work with you to create something that's
              completely, undeniably yours.
            </p>
          </div>

          {/* Values / traits */}
          <ul className="about__traits" aria-label="Artist values">
            <li className="about__trait">
              <span className="about__trait-mark" aria-hidden="true">✦</span>
              Custom designs
            </li>
            <li className="about__trait">
              <span className="about__trait-mark" aria-hidden="true">✦</span>
              Flash available
            </li>
            <li className="about__trait">
              <span className="about__trait-mark" aria-hidden="true">✦</span>
              Traditional designs with a bold modern edge
            </li>
            <li className="about__trait">
              <span className="about__trait-mark" aria-hidden="true">✦</span>
              Tattoo Therapy available for meaningful tattoos
            </li>
          </ul>
        </div>
      </div>
    </section>
  )
}